import {
    GET_LAB_ORDER_CANCEL_REASONS,
    GET_PHARMACY_ORDER_CANCEL_REASONS,
    REJECT_LAB_ORDER,
    ACCEPT_LAB_ORDER,
    ADD_SAMPLING_DATA,
    SAMPLING_DONE,
    SEND_LAB_ORDER_RESULT,
    MAKE_LAB_ORDER_DONE,
    GET_VENDOR_ORDERS,
    ACCEPT_PHARMACY_ORDER,
    REJECT_PHARMACY_ORDER,
} from "../actions/orders";
const initialState = {
    lab_order_cancel_reasons_waiting : false,
    lab_order_cancel_reasons_success : {},
    lab_order_cancel_reasons_error :{},
    pharmacy_order_cancel_reasons_waiting : false,
    pharmacy_order_cancel_reasons_success : {},
    pharmacy_order_cancel_reasons_error :{},
    reject_lab_order_waiting : false,
    reject_lab_order_success : {},
    reject_lab_order_error :{},
    accept_lab_order_waiting : false,
    accept_lab_order_success : {},
    accept_lab_order_error :{},
    add_sampling_data_waiting : false,
    add_sampling_data_success : {},
    add_sampling_data_error :{},
    sampling_done_waiting : false,
    sampling_done_success : {},
    sampling_done_error :{},
    send_lab_order_result_waiting : false,
    send_lab_order_result_success : {},
    send_lab_order_result_error :{},
    make_lab_order_done_waiting : false,
    make_lab_order_done_success : {},
    make_lab_order_done_error :{},
    all_orders_waiting : false,
    all_orders_success : {},
    all_orders_error :{},
    reject_pharmacy_order_waiting : false,
    reject_pharmacy_order_success : {},
    reject_pharmacy_order_error :{},
    accept_pharmacy_order_waiting : false,
    accept_pharmacy_order_success : {},
    accept_pharmacy_order_error :{},
}

export default function orders(state = initialState, action){
    switch (action.type){
        case GET_LAB_ORDER_CANCEL_REASONS:
            return {
                ...state,
                lab_order_cancel_reasons_waiting : action.lab_order_cancel_reasons_waiting,
                lab_order_cancel_reasons_success : action.lab_order_cancel_reasons_response,
                lab_order_cancel_reasons_error : action.lab_order_cancel_reasons_error
            }
        case GET_PHARMACY_ORDER_CANCEL_REASONS:
            return {
                ...state,
                pharmacy_order_cancel_reasons_waiting : action.pharmacy_order_cancel_reasons_waiting,
                pharmacy_order_cancel_reasons_success : action.pharmacy_order_cancel_reasons_response,
                pharmacy_order_cancel_reasons_error : action.pharmacy_order_cancel_reasons_error
            }
        case REJECT_LAB_ORDER:
            return {
                ...state,
                reject_lab_order_waiting : action.reject_lab_order_waiting,
                reject_lab_order_success : action.reject_lab_order_response,
                reject_lab_order_error : action.reject_lab_order_error
            }
        case ACCEPT_LAB_ORDER:
            return {
                ...state,
                accept_lab_order_waiting : action.accept_lab_order_waiting,
                accept_lab_order_success : action.accept_lab_order_response,
                accept_lab_order_error : action.accept_lab_order_error
            }
        case ADD_SAMPLING_DATA:
            return {
                ...state,
                add_sampling_data_waiting : action.add_sampling_data_waiting,
                add_sampling_data_success : action.add_sampling_data_response,
                add_sampling_data_error : action.add_sampling_data_error
            }
        case SAMPLING_DONE:
            return {
                ...state,
                sampling_done_waiting : action.sampling_done_waiting,
                sampling_done_success : action.sampling_done_response,
                sampling_done_error : action.sampling_done_error
            }
        case SEND_LAB_ORDER_RESULT:
            return {
                ...state,
                send_lab_order_result_waiting : action.send_lab_order_result_waiting,
                send_lab_order_result_success : action.send_lab_order_result_response,
                send_lab_order_result_error : action.send_lab_order_result_error
            }

        case MAKE_LAB_ORDER_DONE:
            return {
                ...state,
                make_lab_order_done_waiting : action.make_lab_order_done_waiting,
                make_lab_order_done_success : action.make_lab_order_done_response,
                make_lab_order_done_error : action.make_lab_order_done_error
            }
        case GET_VENDOR_ORDERS:
            return {
                ...state,
                all_orders_waiting : action.all_orders_waiting,
                all_orders_success : action.all_orders_response,
                all_orders_error : action.all_orders_error
            }
        case ACCEPT_PHARMACY_ORDER:
            return {
                ...state,
                accept_pharmacy_order_waiting : action.accept_pharmacy_order_waiting,
                accept_pharmacy_order_success : action.accept_pharmacy_order_response,
                accept_pharmacy_order_error : action.accept_pharmacy_order_error
            }
        case REJECT_PHARMACY_ORDER:
            return {
                ...state,
                reject_pharmacy_order_waiting : action.reject_pharmacy_order_waiting,
                reject_pharmacy_order_success : action.reject_pharmacy_order_response,
                reject_pharmacy_order_error : action.reject_pharmacy_order_error
            }
        default:
            return state;
    }
}